import 'abortcontroller-polyfill/dist/abortcontroller-polyfill-only';
// Chrome 58 has no Intl.PluralRules; the package only installs itself when it is missing or incomplete.
// ES imports run in order, so this must stay above everything that can reach i18n.
import 'intl-pluralrules';
import '@/i18n';
import { StrictMode } from 'react';
import { createRoot } from 'react-dom/client';
import App from '@/App';
// importing the barrels registers the api layer's sessionHooks - keep before hydrate
import { useQltAuthStore } from '@/stores/qlt';
import { useIzteachSessionStore } from '@/stores/izteach';
import { featureEnabled } from '@/config/features';
import { router } from '@/router';
import { installUpdateChecks } from '@/update/store';
import { installSessionHeartbeat } from '@/auth/sessionHeartbeat';
import { dropLegacyBoardKeys } from '@/stores/board/owner';

// kill pinch-zoom and double-tap zoom that the panel WebView still applies past the viewport meta
document.addEventListener(
  'gesturestart',
  (event) => {
    event.preventDefault();
  },
  { passive: false }
);

// board keys from before per-teacher storage belong to an unknown teacher
dropLegacyBoardKeys();

// restore persisted sessions before the first render so no request goes out unauthenticated
useQltAuthStore.getState().hydrate();
useIzteachSessionStore.getState().hydrate();
void useQltAuthStore.getState().validateSession().then((ok) => {
  // SSO: a board signed in before SSO was on, or whose exchange failed, connects IZTeach now
  if (ok && featureEnabled('sso') && useQltAuthStore.getState().isTeacher && !useIzteachSessionStore.getState().accessToken) {
    void useIzteachSessionStore.getState().signInWithQlt();
  }
});

// boards on the remote APK stay open all day; pick up new deploys between lessons
installUpdateChecks(router);
installSessionHeartbeat(router);

const container = document.getElementById('root');

if (!container) {
  throw new Error('Root container #root is missing from index.html');
}

createRoot(container).render(
  <StrictMode>
    <App />
  </StrictMode>
);
